<template>
    <component
        :is="as"
        class="ui-card"
        :class="{ 'ui-card--interactive': interactive, 'ui-card--pulse': pulsing }"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, type Component } from 'vue';

interface Props {
    interactive?: boolean;
    as?: string | Component;
}

withDefaults(defineProps<Props>(), {
    interactive: false,
    as: 'div',
});

const pulsing = ref(false);
let pulseTimer: number | undefined;

const pulse = (durationMs = 2700) => {
    window.clearTimeout(pulseTimer);
    // Drop the class for a frame so a repeated call restarts the CSS animation.
    pulsing.value = false;

    requestAnimationFrame(() => {
        pulsing.value = true;
        pulseTimer = window.setTimeout(() => (pulsing.value = false), durationMs);
    });
};

onBeforeUnmount(() => window.clearTimeout(pulseTimer));

defineExpose({ pulse });
</script>
